import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Users, FlaskConical, Clock, Home } from "lucide-react";

const ITEMS = [
  { icon: Users, value: 5000, suffix: "+", label: "Patients Served" },
  { icon: FlaskConical, value: 100, suffix: "+", label: "Laboratory Tests" },
  { icon: Clock, text: "Same Day", label: "Reports Delivered" },
  { icon: Home, text: "Available", label: "Home Collection" },
];

function Counter({ value, suffix }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const el = ref.current;
    const obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !started.current) {
        started.current = true;
        const dur = 1600, t0 = performance.now();
        const tick = (t) => {
          const p = Math.min((t - t0) / dur, 1);
          setN(Math.floor((1 - Math.pow(1 - p, 3)) * value));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }, { threshold: 0.4 });
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, [value]);
  return <span ref={ref}>{n.toLocaleString()}{suffix}</span>;
}

export default function Stats() {
  return (
    <section className="relative -mt-4 md:mt-0 py-12 md:py-16" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="bg-navy rounded-[2rem] px-6 py-10 md:py-12 shadow-[0_30px_80px_-30px_rgba(10,37,64,0.6)] relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-72 h-72 bg-turq/20 rounded-full blur-3xl" />
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {ITEMS.map((it, i) => (
              <motion.div key={it.label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="text-center" data-testid={`stat-${i}`}>
                <it.icon className="w-7 h-7 text-turq-light mx-auto mb-3" strokeWidth={1.5} />
                <div className="text-3xl md:text-4xl font-bold text-white font-heading">
                  {it.text ? it.text : <Counter value={it.value} suffix={it.suffix} />}
                </div>
                <div className="text-sm text-white/60 mt-1">{it.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
